import { cn } from '../../lib/utils';

const CharacterCounter = ({ current, max, className }) => {
  if (!max) return null;

  const percentage = (current / max) * 100;
  const isWarning = percentage > 80;
  const isError = percentage > 100;

  return (
    <div
      className={cn(
        'text-right text-[11px] mt-1',
        isError ? 'text-red-500' : isWarning ? 'text-orange-500' : 'text-slate-400',
        className
      )}
    >
      {current}/{max}
    </div>
  );
};

export default CharacterCounter;